/**
 * The venue console's own namespace, `console` (spec/13).
 *
 * A separate entry point rather than a member of `namespaces`: the kiosk and the phone apps never
 * load it. The console passes it to `createI18n` as extra resources:
 *
 *   createI18n({ language, extraResources: consoleResources, use: [initReactI18next] });
 */
import consoleEn from './locales/en/console.js';
export const consoleNamespace = 'console';
export const consoleResources = {
    en: { console: consoleEn },
};
//# sourceMappingURL=console.js.map